import { useMemo } from 'react';

import InsightsApiExport from 'components/insights/layout/InsightsApiExport';
import { InsightsQueryParams } from 'components/insights/query/useInsightsAnalytics';
import { getReferralAnalyticsFilters, useReferralsInsightsStore } from 'stores/referralsInsightsStore';

type Props = {
  disabled?: boolean;
  filename?: string;
  show?: boolean;
  params: InsightsQueryParams;
  extraFilters?: Record<string, unknown> | null;
};

export default function ReferralApiExport({ extraFilters = null, ...props }: Props) {
  const baseFilters = useReferralsInsightsStore((state) => getReferralAnalyticsFilters(state));
  const analyticsFilters = useMemo(
    () => (baseFilters ? { ...baseFilters, ...(extraFilters ?? {}) } : null),
    [baseFilters, extraFilters]
  );

  return <InsightsApiExport {...props} analyticsFilters={analyticsFilters} />;
}
